<div *ngIf="busy">Fetching data...</div>
<div *ngIf="ladderOver">
  Thank you for playing! The ladder ended {{DateTime.fromISO(this.ladderInfo.endDate).toLocaleString(DateTime.DATETIME_MED)}}.
  <br /><br />
  <!-- If there is a tournament, you can see it <a href="#" [routerLink]="['/tournament', ladderid]">here</a> -->
</div>


<div *ngIf="!busy && !ladderOver" class="match-new">

  <!-- <div *ngIf="pairings.length == 0">No matches assigned yet... Please be patient... We are waiting for everyone to register.<br /><br /><br /><br />
  </div> -->
  <div *ngIf="pairings.length == 0">Congratulations!! You have played all of your matches (or we haven't started yet)</div>
  <div *ngIf="pairings.length > 0">

    <form [formGroup]="matchForm">
      <input type="hidden" formControlName="pairingId" />
      <span *ngIf="round">Round {{round}}</span>
      <table class="table">
        <tr>
          <td>{{player.isDoubles ? 'Team' : 'Player'}}</td>
          <td>Tiebreaker</td>
        </tr>
        <tr>
          <td>{{player.isDoubles ? player.doublesName : player.getFullName()}}</td>
          <td>
            <select style="margin-left: 5px;" formControlName="Set1Player1Tie">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
        <tr>
          <td>
            <select formControlName="opponentId">
              <option *ngFor="let s of pairings" [value]=s.pairingPlayer.id>{{s.pairingPlayer.name}}</option>
            </select>
          </td>
          <td>
            <select style="margin-left: 5px;" formControlName="Set1Player2Tie">
              <option *ngFor="let i of possibleTieScores" [value]="i">{{i}}</option>
            </select>
          </td>
        </tr>
      </table>

      <div class="show-small" style="margin: 0 20px;">
        <div style="float: left">
          <button [disabled]="!canSave() || busySave" (click)="saveMatch($event)">Submit Match</button>
        </div>
        <div style="float: right;">
          <a [routerLink]="['/home']">Cancel</a>
        </div>
      </div>
      <div class="hide-small">
        <button [disabled]="!canSave() || busySave" (click)="saveMatch($event)">Submit Match</button>

        <a style="padding-left: 40px;" href="#" (click)="saveForfeit($event)">Submit Forfeit</a>
        &nbsp;
        <a [routerLink]="['/home']">Cancel</a>
      </div>


    </form>
  </div>
</div>